import {
  type CookieItem,
  type CookieList,
} from 'hb-react/shared/apps/CookieBanner/types';

export const getSectionsData = (
  Content: React.ForwardRefExoticComponent<{
    cookieList: Array<CookieItem>;
    ref: any;
    typeDescription: string;
  }>,
  cookieList: CookieList,
) => {
  const sections = [
    {
      title: __('Required cookies (always active)'),
      type: 'required',
      checked: true,
      disabled: true,
      children: ({ ref }) => (
        <Content
          ref={ref}
          cookieList={cookieList.required}
          typeDescription={s__(
            'CookieBanner|Cookies that are essential for critical functionality to work on the platform.',
          )}
        />
      ),
    },
    {
      title: __('Functional cookies'),
      type: 'functional',
      checked: false,
      disabled: false,
      children: ({ ref }) => (
        <Content
          ref={ref}
          cookieList={cookieList.functional}
          typeDescription={s__(
            'CookieBanner|Cookies that enable functionality on the platform. Deactivating these may result in some features not being available to you.',
          )}
        />
      ),
    },
    {
      title: __('Tracking cookies'),
      type: 'tracking',
      checked: false,
      disabled: false,
      children: ({ ref }) => (
        <Content
          ref={ref}
          cookieList={cookieList.tracking}
          typeDescription={s__(
            'CookieBanner|Cookies used to gather analytics on user behaviour on the platform in order to make improvements to the user experience.',
          )}
        />
      ),
    },
  ];

  return sections;
};
